<template>
  <template v-for="(value, key, idx) in jsonObj">
    <v-list-group
      v-if="isObject(value)"
      :key="idx"
      class="ml-n4"
      :draggable="true"
      @dragstart="
        ondragActivation ? onDrag($event, `${path}.${key}`, value) : ''
      "
    >
      <template v-slot:activator="{ props }">
        <v-list-item v-bind="props" :title="formatTitle(value, path, key)">
          <template v-slot:prepend>
            <v-icon
              :icon="
                Array.isArray(value) ? 'mdi-code-brackets' : 'mdi-code-braces'
              "
              :color="
                Array.isArray(value) ? 'light-blue-darken-2' : 'orange-darken-2'
              "
            ></v-icon>
          </template>
        </v-list-item>
      </template>

      <SimpleTreeNode
        :jsonObj="value"
        :path="path + '.' + key"
        @onDrag="onDrag"
      />
    </v-list-group>
    <v-list-item
      v-else
      :title="key"
      :subtitle="JSON.stringify(value)"
      :key="`item-${idx}`"
      class="ml-n4"
      :draggable="true"
      @dragstart="
        ondragActivation
          ? onDrag($event, `${path}.${key}`, JSON.stringify(value))
          : ''
      "
    >
      <template v-slot:prepend>
        <v-icon icon="mdi-leaf" color="green-darken-2"></v-icon>
      </template>
    </v-list-item>
  </template>
</template>

<script>
import { drag } from "@/mixins/common-utils.js";
export default {
  name: "SimpleTreeNode",
  props: ["path", "jsonObj", "ondragActivation"],
  emits: ["onDrag"],
  methods: {
    //Checks if the item is an object
    isObject(obj) {
      return obj !== null && (typeof obj === "object" || Array.isArray(obj));
    },
    //Formats nested object title in eg.: paretNode[0]
    formatTitle(value, path, key) {
      const length = Object.keys(value).length;
      if (length > 0) {
        if (!Array.isArray(value) && typeof key !== "string") {
          return `${path.replace(/^.*\./, "")}[${key}]`;
        }
        return key;
      }
    },
  },
  setup(props, { emit }) {
    //Invoke onDrag parent event
    function onDrag(event, key, value) {
      emit("onDrag", event, key, value);
    }

    return { drag, onDrag };
  },
};
</script>
